export function getToken(): string {
  return localStorage.getItem('access_token') || localStorage.getItem('token') || '';
}

export function authHeaders(): Record<string, string> {
  return {
    Authorization: 'Bearer ' + getToken(),
    'Content-Type': 'application/json',
  };
}

export function formatDate(iso?: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
}

export function periodBadgeColor(freq?: string): string {
  const f = (freq || '').toLowerCase();
  if (f.includes('semi') || f === 'semimonthly') return '#15A08C';
  if (f.includes('bi') || f === 'biweekly') return '#7F77DD';
  if (f === 'monthly') return '#EF9F27';
  if (f === 'weekly') return '#D85A30';
  return '#5F5E5A';
}

export function periodBadgeBg(freq?: string): string {
  const f = (freq || '').toLowerCase();
  if (f.includes('semi') || f === 'semimonthly') return '#E1F5EE';
  if (f.includes('bi') || f === 'biweekly') return '#EEEDFE';
  if (f === 'monthly') return '#FAEEDA';
  if (f === 'weekly') return '#FAECE7';
  return '#F1EFE8';
}

export function periodBadgeText(freq?: string): string {
  const f = (freq || '').toLowerCase();
  if (f.includes('semi') || f === 'semimonthly') return '#04342C';
  if (f.includes('bi') || f === 'biweekly') return '#26215C';
  if (f === 'monthly') return '#633806';
  if (f === 'weekly') return '#4A1B0C';
  return '#2C2C2A';
}